import { render, staticRenderFns } from "./CakeshopsNewStepThree.vue?vue&type=template&id=249e34c9&"
import script from "./CakeshopsNewStepThree.vue?vue&type=script&lang=js&"
export * from "./CakeshopsNewStepThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports